module.exports = {"511528100":"古宋镇","511528101":"僰王山镇","511528103":"共乐镇","511528105":"莲花镇","511528107":"九丝城镇","511528108":"石海镇","511528110":"周家镇","511528111":"五星镇","511528200":"大坝苗族乡","511528205":"大河苗族乡","511528206":"麒麟苗族乡","511528207":"仙峰苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511528.json
// module id = 2495
// module chunks = 0